import { UploadIcon } from '../../icons';

const FileUploader = ({ acceptedTypes, handleFileChange, fileName }) => {
  const onFileChange = (event) => {
    handleFileChange(event);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <label
          htmlFor="file-upload"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            backgroundColor: '#E6B471',
            color: '#000',
            fontSize: '14px',
            padding: '10px 16px',
            borderRadius: '8px',
            cursor: 'pointer',
            border: 'none',
            outline: 'none',
            width: 'fit-content',
          }}
        >
          <UploadIcon style={{ width: '17px', height: '17px' }} />
          Upload File
        </label>

        {fileName && <span style={{ fontSize: '14px', color: '#000' }}>{fileName}</span>}
      </div>

      <input
        id="file-upload"
        type="file"
        accept={acceptedTypes}
        onChange={onFileChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default FileUploader;
